module.exports = __webpack_public_path__ + "static/media/indigo_logo_1.02d8e9fe.png";